import { all, fork } from "redux-saga/effects"
import checkLoginSaga from "./checkLogin"
import userSaga from "./user"
import youtubeSaga from "./youtube"
import menuSaga from "./menu"
import boardSaga from "./board"

export default function* rootSaga() {
    yield all([fork(checkLoginSaga), fork(userSaga), fork(youtubeSaga), fork(menuSaga), fork(boardSaga)])
}
